import React from 'react';

import img from '../../assets/hirewell_logo.png';

import styles from './HirewellLogo.scss';

export function HirewellLogo() {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.hirewellTextBlock}>
          <h3>High-touch recruitment</h3>
          <div className={styles.hirewellText}>
            Rainmakers is powered by Hirewell - a global recruiting partner built for high-touch,
            strategic hiring. Not just sales. We offer expert support acress every department.
          </div>
          <a href="https://hirewell.com" className={styles.learnMore}>
            Learn More
          </a>
        </div>
        <img src={img} alt="Hirewell logo" />
      </div>
    </div>
  );
}
